import React from "react";
import { Label } from "reactstrap";
import Required from "../validate/Required";
import { handleStatusChange } from "../../utils/myFunctions";
import Select from "react-select";

const Status = ({ register, watch, errors,setValue, trigger }) => {
  return (
    <div className="form-group">
      <Label className="from-label" htmlFor="status">
        Status
        <Required />
      </Label>
      <div className="form-control-wrap">
        <Select
          className=""
          id="status"
          options={[
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
          {...register("status", {
            required: "Please select status",
          })}
          onChange={(e) => handleStatusChange(setValue, e, trigger)}
          value={watch("status")}
        />
        {errors.status && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors?.status?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Status;
